module.exports = __webpack_public_path__ + "static/media/logo-GC-2021.0dbbba7d.png";